import { createFileRoute } from "@tanstack/react-router";
import { EndrePrivatAvtalePage } from "@/features/avtaler/EndrePrivatAvtalePage";

export const Route = createFileRoute("/_app/avtaler/$avtalerId/privat/endre/")({
  component: EndrePrivatAvtalePage,
  head: () => ({
    meta: [
      {
        title: "Endre bestilling | Norgespris for Fjernvarme",
      },
    ],
  }),
});
